export function getAccessToken() {
  return sessionStorage.getItem("access_token") || "";
}

export function getIdToken() {
  return sessionStorage.getItem("id_token") || "";
}

export function getRefreshToken() {
  return sessionStorage.getItem("refresh_token") || "";
}

export function getSessionCookie() {
  return sessionStorage.getItem("sessionCookie") || "";
}
export function setSessionCookie(name: string, value: string) {
  sessionStorage.setItem(name, value);
}

export function getCorrelationID() {
  return sessionStorage.getItem("correlationID") ?? "";
}

export function getPermission() {
  return sessionStorage.getItem("permission") ?? "";
}

export function getEmail() {
  return sessionStorage.getItem("email") ?? "";
}

export function setCorrelationID(item: string) {
  sessionStorage.setItem("correlationID", item);
}

export function getNextEndpoint() {
  return sessionStorage.getItem("next") ?? "";
}

export function setNextEndpoint(item: string) {
  return sessionStorage.setItem("next", item);
}

export function getSessionItem(item: string) {
  return sessionStorage.getItem(item);
}

export function logoutUser() {
  window.sessionStorage.clear();
  window.sessionStorage.setItem("isLogout", "true");
}
